import "leaflet/dist/leaflet.css";
import './assets/main.css'
import { createApp } from 'vue'
import {waiter} from "@/context/global.js";
import {elog} from "@/engine/helpers/logging.js";
import {UITemplates} from "@/engine/UITemplates.js";

// leaflet should be loaded at first even before main App.vue
// in order to the correct L object will be accessed to all our components
import 'leaflet'
import "@/engine/leaflet/leaflet-geoman.min.js"
import "@/engine/leaflet/leaflet-wfst.src.js"
import "@/engine/leaflet/antimeridianUtils.js"
import 'path-data-polyfill'
import "@/engine/leaflet/leaflet-sidebar.js"
import "@/engine/leaflet/leaflet.filelayer.js"
import "@/engine/leaflet/leaflet.contextmenu.js"
import "@/engine/leaflet/leaflet.GeometryDimension.js"
import "@/engine/leaflet/Leaflet.StyleEditor.js"
import "@/engine/leaflet/VectorTileLayer.js"
import "@/engine/leaflet/easy-button.js"
import "@/engine/leaflet/L.Control.Window.js"

import App from './App.vue'

// init preloading templates and wait for the templates to be loaded
waiter.add( function () {
    return UITemplates.ready;
}, 5000, function () {
    elog("ERROR", "content is still not loaded")
})

createApp(App).mount('#app')
